import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { sortBy, orderBy, sumBy, groupBy } from 'lodash';
import { typedEntries } from '../../../../utils/type-helpers';
const CPD_CATEGORY_TYPE_CONFIG = {
    CoreTopic: { label: 'Legislative CPD', order: 0 },
    SubTopic: { label: 'ASIC Knowledge Areas', order: 1 },
    Other: { label: 'Other', order: 2 }
};
const hasPointsValue = (points) => points !== undefined && points !== null && points !== '';
const pointsAsNumber = (points) => hasPointsValue(points) ? Number(points) || 0 : 0;
const resolveCategoryType = (category) => category.categoryType in CPD_CATEGORY_TYPE_CONFIG
    ? category.categoryType
    : 'Other';
export const TooltipWrapper = ({ fullCpdCategory, className = '', category, clickHandler, trigger = 'click' }) => {
    const [showTooltip, setShowTooltip] = useState(true);
    const categoriesByType = groupBy(fullCpdCategory, resolveCategoryType);
    const typeEntries = typedEntries(categoriesByType);
    const sortedTypeEntries = sortBy(typeEntries, ([type]) => CPD_CATEGORY_TYPE_CONFIG[type].order);
    const coreTopicEntry = sortedTypeEntries.find(([type]) => type === 'CoreTopic');
    const totalAddedPoints = coreTopicEntry === undefined
        ? 0
        : sumBy(coreTopicEntry[1], ({ points }) => Number(points || 0));
    const hasAnyPoints = fullCpdCategory.some(({ points }) => hasPointsValue(points));
    const tooltip = (React.createElement(Popover, { id: 'cpd-category-name-tooltip' },
        sortedTypeEntries.map(([cpdCategoryType, categoriesInType]) => {
            if (!categoriesInType)
                return null;
            const sortedTypeCategories = orderBy(categoriesInType, [
                (c) => (hasPointsValue(c.points) ? 0 : 1),
                (c) => pointsAsNumber(c.points)
            ], ['asc', 'desc']);
            return (React.createElement("div", { key: cpdCategoryType, className: 'cpd-type-group' },
                React.createElement("div", { className: 'cpd-type-title' },
                    CPD_CATEGORY_TYPE_CONFIG[cpdCategoryType].label,
                    ":"),
                React.createElement("ul", { className: 'grouped-list' }, sortedTypeCategories.map(({ cpdCategoryId, name, points }) => (React.createElement("li", { key: cpdCategoryId, className: 'cpd-item' },
                    React.createElement("span", { className: 'cpd-name' }, name),
                    hasPointsValue(points) && (React.createElement("span", { className: 'cpd-points' },
                        points,
                        " hr/s"))))))));
        }),
        hasAnyPoints && (React.createElement("div", { className: 'cpd-total' },
            React.createElement("strong", null, "Total:"),
            " ",
            totalAddedPoints,
            " hr/s"))));
    const mouseOverHandler = (e) => {
        const target = e.currentTarget;
        setShowTooltip(target.offsetWidth < target.scrollWidth);
    };
    const child = (React.createElement("span", { className: `${className} clickable`, style: {
            display: 'inline-block',
            maxWidth: '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            verticalAlign: 'bottom'
        }, onMouseOver: mouseOverHandler, onClick: clickHandler }, category));
    return fullCpdCategory.length > 1 || showTooltip ? (React.createElement(OverlayTrigger, { placement: 'top', trigger: trigger, overlay: tooltip }, child)) : (child);
};
export default TooltipWrapper;



//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/app/partials/tooltip-wrapper.tsx
// module id = 207
// module chunks = 0